import { Mqtt_Topics_userChanges } from "../ThreeDocs.Models/Api/Api.js";
import { singleton } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Msg } from "./UserProfileTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_userChanges(uid)), (Item) => (new Msg(8, [Item]))];
}

